import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/parts-management')({
  component: PartsManagementLayout,
});

function PartsManagementLayout() {
  return <Outlet />;
}
